import { Typography } from '@/app/common';
import { cn } from '@workspace/lib';

export function TimelineHeading({ text }: { text: string }) {
  return (
    <Typography className={cn('text-center font-bold')} variant="h2" styleVariant="h3">
      {text}
    </Typography>
  );
}
